import React from 'react'
import { withTranslation } from 'react-i18next'

const RATES = [
  { key: 'sales_commission', value: '5.00% of net qualifying sales' },
  { key: 'reward_ads', value: 'GHS 0.20 per valid view' },
  { key: 'sponsored_quiz', value: 'GHS 0.20 per completed round' },
  { key: 'sponsored_prediction', value: 'GHS 0.20 per prediction entry' },
  { key: 'setup_fee', value: 'GHS 5,000 per campaign' }
]

export const CommercialTermsList = withTranslation()(function CommercialTermsList({ t, showActiveTag = true }) {
  return (
    <div className="w-full">
      {
        showActiveTag && (
          <div className="flex items-center justify-between gap-4 mb-4">
            <span className="inline-flex items-center bg-success bg-opacity-10 text-success text-xs px-1.5 py-0.5 rounded">
              {t('billing.commercial_terms.active_terms')}
            </span>
            <p className="text-base text-secondary">{t('billing.commercial_terms.effective_from', { date: '01 Jan 2026' })}</p>
          </div>
        )
      }

      {
        RATES.map(({ key, value }, index) => (
          <div key={key} className={`flex items-start justify-between gap-4 py-2.5 ${index < RATES.length - 1 ? 'border-b border-border-lines' : ''}`}>
            <p className="text-secondary">{t(`billing.commercial_terms.${key}`)}</p>
            <p className="text-dark-blue">{value}</p>
          </div>
        ))
      }
    </div>
  )
})

export default withTranslation()(function CommercialTermsCard({ t, onViewAll }) {
  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <p className="text-base font-semibold text-dark-blue">{t('billing.commercial_terms.title')}</p>

        <button type="button" onClick={onViewAll} className="flex items-center gap-1.5 text-primary text-sm font-semibold whitespace-nowrap">
          {t('billing.commercial_terms.view_all')} <span aria-hidden>→</span>
        </button>
      </div>

      <CommercialTermsList />
    </div>
  )
})
